export default "__VITE_ASSET__b34dd9b9__"